import { Link } from 'react-router-dom';
import './Products.css';

const Products = () => {
  const productCategories = [
    {
      title: 'Roll Forming Machines',
      description: 'Complete roll forming lines with cutting-edge technology',
      link: '/products/roll-forming-machines',
      image: '🏭'
    },
    {
      title: 'Tooling & Dies',
      description: 'Custom and standard tooling for various industries',
      link: '/products/tooling',
      image: '🔧'
    },
    {
      title: 'Uncoilers & Presses',
      description: 'High-capacity uncoilers and hydraulic presses',
      link: '/products/uncoilers-presses',
      image: '🏗️'
    },
    {
      title: 'Equipment Inventory',
      description: 'New and used machinery available for immediate delivery',
      link: '/products/used-equipment',
      image: '📦'
    }
  ];

  return (
    <div className="products-page">
      <div className="container">
        <h1>Our Products</h1>
        <p className="page-intro">
          Explore our comprehensive range of roll forming equipment and tooling solutions
        </p>
        
        <div className="product-grid">
          {productCategories.map((category, index) => (
            <Link to={category.link} key={index} className="product-card">
              <div className="product-icon">{category.image}</div>
              <h3>{category.title}</h3>
              <p>{category.description}</p>
              <span className="learn-more">Learn More →</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Products;